import { defineMessages } from "react-intl";

export const attributeRowMessages = defineMessages({
  multipleValueLabel: {
    id: "j8PV7E",
    defaultMessage: "Values",
    description: "attribute values",
  },
  valueLabel: {
    id: "fgHLXc",
    defaultMessage: "Value",
    description: "attribute value",
  },
  reference: {
    id: "Ediw6/",
    defaultMessage: "Assign references",
    description: "button label",
  },
});
